import * as globals from '@wandb/common/css/globals.styles';
import {Menu} from 'semantic-ui-react';
import styled, {css} from 'styled-components';

export const StyledButtonWrapper = styled.div`
  cursor: pointer;
  height: 24px;
  width: 24px;

  margin-right: 8px;

  :hover {
    color: ${globals.TEAL};
  }
`;

export const StyledDropdownText = styled.span`
  min-width: 60px;
  font-size: 16px;
`;

export const StyledMenuItem = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  font-size: 16px !important;
`;

// All this style stuff should be removed once we have a Menu component in the design system
const panelActionStyles = css`
  .panel-action,
  .item .panel-action {
    // original semantic ui padding: 0.9375em 1.125em;
    // to add a hover state we have to increase margin and decrease padding
    // styles need !important or they'll be overridden by semantic ui stuff

    margin: 0.3125em 0.5em !important;
    padding: 0.625em !important;
    padding-right: 0 !important;
    border-radius: 4px !important;

    :hover {
      background-color: ${globals.GRAY_TRANSPARENT} !important;
    }
  }
`;

export const StyledMenu = styled(Menu)`
  ${panelActionStyles}

  .panel-action-delete {
    :hover {
      background-color: ${globals.RED_LIGHT_TRANSPARENT} !important;
    }
  }
`;
export const StyledMenuItemContainer = styled.span`
  ${panelActionStyles}
`;
